<template>
  <view>
    <TwPopup title="操作" :open="open" :showFooter="false" @change="change">
      <view class="a-p-30-0-154-0 a-flex a-col a-ai-c">
        <view
          class="a-fs-32 a-fw-500 a-lh-32 a-mb-20 a-w-630 a-h-92 a-br-12 a-bg-#F2F3F5 a-c-#141414 a-flex a-ai-c a-jc-c"
          @click="openRemark"
          >{{ activeCarItem && activeCarItem.productCode ? '编辑' : '添加' }}地点备注名</view
        >
        <view
          class="a-fs-32 a-fw-500 a-lh-32 a-mb-20 a-w-630 a-h-92 a-br-12 a-bg-#F2F3F5 a-c-#141414 a-flex a-ai-c a-jc-c"
          @click="openSelectPlace"
          >修改地点</view
        >
        <view
          class="a-fs-32 a-fw-500 a-lh-32 a-w-630 a-h-92 a-br-12 a-bg-#F2F3F5 a-c-#FA2C2C a-flex a-ai-c a-jc-c"
          @click="handleDelete"
          >删除</view
        >
      </view>
    </TwPopup>
    <AddPlaceRemark
      :open="openRemarkDialog"
      :activeCarItem="activeCarItem"
      @change="(show) => (openRemarkDialog = show)"
    />
    <SelectPlace
      ref="selectPlaceRef"
      selectType="edit"
      :activeCarItem="activeCarItem"
      :defaultCityData="activeCityItem"
    />
  </view>
</template>

<script>
import TwPopup from '@/componentsV3/common/tw-popup/index.vue';
import AddPlaceRemark from './AddPlaceRemark.vue';
import SelectPlace from './SelectPlace.vue';

export default {
  components: { TwPopup, AddPlaceRemark, SelectPlace },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    activeCarItem: Object,
    activeCityItem: Object,
  },
  data() {
    return {
      openRemarkDialog: false,
    };
  },
  methods: {
    openRemark() {
      this.openRemarkDialog = true;
    },
    openSelectPlace() {
      this.$refs.selectPlaceRef.open();
    },
    change(show) {
      this.$emit('change', show);
    },
    handleDelete() {
      this.change(false);
      this.$emit('delete', this.activeCarItem);
    },
  },
};
</script>
